/**
 * Strip JSX labels before persisting an option to invoice.json. The dropdown
 * can rebuild a rich label at render time via toSelectOption + code/name.
 *
 * @param {object} choice - A react-select option.
 * @returns {object} The option with a string label (`code - name`, else `code`,
 *   `name` or the value); anything that is not an object is returned as is.
 */
export const toPersistableOption = (choice) => {
  if (!choice || typeof choice !== 'object') return choice;
  const labelIsPrimitive = typeof choice.label === 'string' || typeof choice.label === 'number';
  if (labelIsPrimitive) return choice;
  const c = choice.code;
  const d = choice.name;
  const safeLabel = c && d ? `${c} - ${d}` :
                   (c ?? d ?? (choice.value != null ? String(choice.value) : ''));
  return { ...choice, label: safeLabel };
};
